import React, { useState, useEffect, useRef } from "react";
import Spinner from "../spinner/spinner";
import Questionaire from "./questionaire";
import {useNavigate } from "react-router-dom";
import { withParams } from "../../utils/withParams";
import {connect} from "react-redux";
import {SocialEngineeringModule,AddModuleAnswers,AddGameTime} from "../../redux/action/action";
import { Data } from "../data/socialengineeringData";
// import Image1 from "../Rander/boat3.png";
import Image1 from "../Rander/malwareboat.png";
import Result from "../modulesresult/result";
// import Flag from "../Rander/flags/engineering.gif";

let detourCounter = 0;
function Question(props) {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [showAnswers, setShowAnswers] = useState(false);
  const [wrongAnswers, setWrongAnswers] = useState(false);
  const [time, setTime] = useState(false);
  const [firstIndex, setForFirstIndex] = useState(true);
  const [counter, setCounter] = useState(0);
  const [running, setRunning] = useState(false);
  // Guards against the commit effect below dispatching its totals more than
  // once, mirroring the moduleCommitted ref used in the other modules'
  // handleNextModule.
  const moduleCommitted = useRef(false);
  // Becomes true only AFTER the commit effect below has dispatched
  // AddGameTime/AddModuleAnswers. <Result/> is gated on this (not on the
  // raw success condition) so it mounts one render later than the commit —
  // if it mounted in the SAME render, React would run Result's own mount
  // effect (which reads these very totals from Redux and submits them,
  // once, via its resultSubmitted ref) before this component's effect below,
  // since child effects fire before parent effects in the same commit. That
  // would permanently submit a campaign result missing this module's score
  // and time.
  const [committed, setCommitted] = useState(false);
  // Tracks wrong answers for the CURRENT attempt only; it resets on every
  // fresh mount of this module (e.g. after a detour/retry), so a failed
  // attempt's mistakes never get added on top of the attempt that actually
  // completes the module.
  const [wrongCount, setWrongCount] = useState(0);

    // Calculate Time...............
       useEffect(() => {
        let interval;

        if (!running) {
          return () => {};
        }
        interval = setInterval(() => {
          setCounter((counter) => counter + 1);
        }, 1000);

        return () => {
          clearInterval(interval);
        };
      }, [running]);


  useEffect(() => {
       const data = Data();
       const quiz_questions = data.map((question) => ({
          ...question,
          answers: [
            question.correct_answer,
            ...question.incorrect_answers,
          ].sort(() => Math.random() - 0.5),
        })).sort(() => Math.random() - 0.5);
        setQuestions(quiz_questions);
  }, []);

  // This is the last level, so once it is cleared SUCCESSFULLY, accumulate
  // this attempt's time and answer tally here instead of calling the
  // campaign result API per-level. Gated on the exact same condition that
  // reveals the <Result/> screen below (currentIndex===3, a perfect score,
  // and the ~2s settle delay via `time`) — NOT on `time` alone — because a
  // failed attempt that gets retried via "Sail Back" must never contribute
  // to the cumulative totals: there would be no way to undo a premature
  // dispatch once it has landed in Redux, and the retry's own numbers would
  // then be added on top, inflating the final result. This mirrors the
  // other modules, which only ever commit inside their "proceed to next"
  // handler (reachable only on success), guarded by the same moduleCommitted
  // ref pattern.
  useEffect(() => {
    if (
      currentIndex === 3 &&
      wrongAnswers === false &&
      score === 3 &&
      time === true &&
      !moduleCommitted.current
    ) {
      moduleCommitted.current = true;
      props.AddGameTime(counter);
      props.AddModuleAnswers(score, wrongCount);
      setCommitted(true);
    }
  }, [currentIndex, wrongAnswers, score, time, counter, wrongCount]);

  const handleAnswer = (answer) => {
  setRunning(true);
    if (!showAnswers) {
      const isCorrect = answer === questions[currentIndex].correct_answer;
      if (isCorrect) {
        setScore(score + 1);
        setWrongAnswers(false);
      }
      else{
        setWrongAnswers(true);
        setWrongCount(wrongCount + 1);
      }
    }
    setShowAnswers(true);
    handleNextQuestion();
  };


  const handleNextQuestion = (updatedScore) => {
    setCurrentIndex(currentIndex + 1);
    setShowAnswers(false);
    if(currentIndex === 2)
    {
      props.SocialEngineeringModule(updatedScore,detourCounter);
      setTimeout(() => {
        setTime(true);
      }, 2000);
    }
    if(currentIndex === 1 && updatedScore === 0)
    {
      setForFirstIndex(false);
    }
  };


  const handleDetour = () => {
    detourCounter = detourCounter + 1;
    navigate(withParams("/cyberisland/socialengineeringtoolkit"));
    setScore(0);
    // navigate() above goes to a different route (the toolkit screen), which
    // remounts this component fresh on return — but reset defensively too,
    // in case that routing ever changes to an in-place retry. The commit
    // effect above only fires on an actual success, so this is unreachable
    // in practice (moduleCommitted can't be true when "Sail Back" is shown),
    // but we reset it anyway for the same defense-in-depth reason as
    // wrongCount.
    setWrongCount(0);
    moduleCommitted.current = false;
    setCommitted(false);
  }
  const handleNextModule = () => {
    props.SocialEngineeringModule(score,detourCounter);
    navigate({pathname:"/denailservicemodule",
  });
  }

  return (
    <>
    {currentIndex === 3 && wrongAnswers === false && score === 3 && time === true && committed ?
      <Result counter={counter} score={score} />
    :
    <div className="container-fluid p-0 set-height">
     {currentIndex === 0 &&
       <img src={Image1} alt="Logo" className="set-boat20" />
      }
      {currentIndex === 1 &&  wrongAnswers === false && score === 1 ?
       <img src={Image1} alt="Logo" className="set-boat21" />
      :
      currentIndex === 1 &&  wrongAnswers === true && score === 1 &&
       <img src={Image1} alt="Logo" className="set-boat21-move" />
      }
      {currentIndex === 2 && wrongAnswers === false && (score === 2 || score === 1) ?
       <img src={Image1} alt="Logo" className="set-boat22" />
      :
      currentIndex === 2 && wrongAnswers === true && (score === 2 || score === 1) &&
      <img src={Image1} alt="Logo" className="set-boat22-move"/>
     }
     {currentIndex === 3 && wrongAnswers === true && score === 2 ?
     <>
      <img src={Image1} alt="Logo" className="set-boat23-move"/>
      <div className="result-fail">
      <h1>
        You're Lost !
      </h1>
       <button onClick = {handleDetour} className="detour">Sail Back</button>
      </div>
     </>
      :
       currentIndex === 3 && wrongAnswers === true && score === 1 && firstIndex === false &&
       <img src={Image1} alt="Logo" className="set-boat22-move" />
    }
    {currentIndex === 3 && wrongAnswers === true && score === 1 && firstIndex === true &&
    <img src={Image1} alt="Logo" className="set-boat22-move" />
    }
    {currentIndex === 3 && wrongAnswers === false && score === 1 &&
       <img src={Image1} alt="Logo" className="set-boat21" />
    }
    {currentIndex === 3 && wrongAnswers === false && score === 2 && firstIndex === true ?
      <img src={Image1} alt="Logo" className="set-boat-last-index" />
    :
    currentIndex === 3 && wrongAnswers === false && score === 2 && firstIndex === false &&
    <img src={Image1} alt="Logo" className="set-boat-last-index" />
    }
    {currentIndex === 3 && score === 3 && wrongAnswers === false &&
     <img src={Image1} alt="Logo" className="set-boat23" />
    }
    {wrongAnswers === true && score === 0 &&
      <img src={Image1} alt="Logo" className="set-boat21-move" />
     }
      {questions.length > 0 ? (
        <>
         {currentIndex === 3 && score!==3 &&
            <div className="result-fail">
            <h1>
              You're Lost !
            </h1>
             <button onClick = {handleDetour} className="detour">Sail Back</button>
            </div>
          }
            {currentIndex!==3 &&
            <Questionaire
              handleAnswer={handleAnswer}
              showAnswers={showAnswers}
              handleNextQuestion={handleNextQuestion}
              data={questions[currentIndex]}
            />
            }

        </>
      ) : (
        <div className="container set-center">
          <Spinner />
        </div>
      )}
    </div>
    }
  </>
  );
}
export default connect(null, {SocialEngineeringModule,AddModuleAnswers,AddGameTime}) (Question);
